






import { Component, Vue, Prop, } from 'vue-property-decorator';

@Component({
})
export default class Badge extends Vue {
	@Prop() public type: BadgeType;
	@Prop({default: 'small'}) public size?: BadgeSize;

	private get badgeClass(): string {
		return `${this.badgeTypeClass} ${this.badgeSizeClass}`;
	}

	private get badgeTypeClass(): string {
		return 'is-' + (this.type ? this.type : 'disabled');
	}

	private get badgeSizeClass(): string {
		if ( this.size === 'large') {
			return 'large-tag';
		} else if ( this.size === 'medium') {
			return 'medium-tag';
		} else {
			return 'small-tag';
		}
	}
}

type BadgeType = 'disabled' | 'danger' | 'warning' | 'info' | 'link' | 'primary' | 'success';
type BadgeSize = 'small' | 'medium' | 'large';

